import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 21a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9m-.844-5.906v-2.25h-2.25A.84.84 0 0 1 8.062 12c0-.468.377-.844.844-.844h2.25v-2.25c0-.467.376-.844.844-.844s.844.377.844.844v2.25h2.25c.467 0 .844.376.844.844a.84.84 0 0 1-.844.844h-2.25v2.25a.84.84 0 0 1-.844.844.84.84 0 0 1-.844-.844"
    }, null, -1)
  ]))]))
}
export default { render: render }